import styles from "./simulator.module.css";

export default function Simulator({ children }: { children: React.ReactNode }) {
  return <section className={styles.section}>{children}</section>;
}
